(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-template-2"] && !Shopify.designMode) return;
  try {
    var swiper = new Swiper('.press-slider-wrapper', {
  slidesPerView: 1.3,
  spaceBetween: 10,
   pagination: {
        el: ".press-pagination",
        type: "fraction",
    },
  navigation: {
    nextEl: '.press-next',
    prevEl: '.press-prev',
  },
  breakpoints: {
    // Mobile landscape and small tablets
    480: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    // Tablets
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    // Desktop
    1024: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    // Large desktop
    1200: {
      slidesPerView: 3,
      spaceBetween: 30,
    }
  }
});
  } catch(e) { console.error(e); }
})();

})();
